<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark> Ver Retraso </v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <p class="mb-0"><b>ID:</b> {{ input.id }}</p>
            <p class="mb-0"><b>Programa:</b> {{ input.nombre_programa }}</p>
            <p class="mb-0"><b>Realizado por:</b> {{ input.realizado_por }}</p>
            <p class="mb-0"><b>Tipo retraso:</b> {{ input.tipo_retraso }}</p>
            <p class="mb-0"><b>Cantidad retraso:</b> {{ input.cantidad_retraso }}</p>
            <p class="mb-0"><b>Concepto:</b> {{ input.nombre_concepto }}</p>
            <p class="mb-0"><b>Movimiento:</b> {{ input.movimiento }}</p>
            <p class="mb-0"><b>Motivo:</b> {{ input.motivo }}</p>
            <p class="mb-0"><b>Registro:</b> {{ input.fecha_registro }}</p>
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" :disabled="loading" class="green" dark>Registrar</v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        input: {},
      };
    },
    components: {},
    watch: {},
    methods: {
      openmodal(idretraso) {
        this.msg = '';
        this.dialog = true;
        this.input = {};
        this.getretraso(idretraso);
      },

      getretraso(idretraso) {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/retraso/programas/${idretraso}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log(data);
            vue.input = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
